/* eslint-disable no-shadow */
import moment from "moment";
import i18n from "@/i18n";
import DateFormatter from "@/constants/date-format/DateFormatter";
import FetchStatus from "@/constants/fetch-status/FetchStatus";
import {
	GetDateTime,
	GetDateTimeError,
	GetDateTimeSuccess,
	GetLastDayPeriod,
	GetLastMonthPeriod,
	GetLastWeekPeriod,
	GetSelectedPeriod,
	OpenDateTimePicker,
	ResetDateTime,
} from "@/stores/actions/DateTimePicker";

const state = {
	status:             FetchStatus.Init,
	error:              {},
	startDate:          DateFormatter.START_DATE,
	startTime:          DateFormatter.TIME_NOW,
	endDate:            DateFormatter.END_DATE,
	endTime:            DateFormatter.TIME_NOW,
	humanStartDate:     DateFormatter.HUMAN_START_DATE,
	humanEndDate:       DateFormatter.HUMAN_END_DATE,
	APIStartDateTime:   DateFormatter.API_START_DATE_TIME,
	APIEndDateTime:     DateFormatter.API_END_DATE_TIME,
	selectedPeriod:     "",
	showDateTimePicker: false,
};

const actions = {
	[GetDateTime]: ({ commit }, data) =>
	{
		const formattedData = {};

		formattedData.humanStartDate = data.humanStartDate;
		formattedData.humanEndDate = data.humanEndDate;
		formattedData.startTime = data.startTime;
		formattedData.endTime = data.endTime;

		formattedData.startDate = moment(`${formattedData.humanStartDate} ${formattedData.startTime}`, "DD/MM/YYYY HH:mm")
			.format("YYYY-MM-DD");
		formattedData.endDate = moment(`${formattedData.humanEndDate} ${formattedData.endTime}`, "DD/MM/YYYY HH:mm")
			.format("YYYY-MM-DD");

		formattedData.APIStartDateTime = DateFormatter
			.DDMMYYYYHHMMToUTC(`${formattedData.humanStartDate} ${formattedData.startTime}`);
		formattedData.APIEndDateTime = DateFormatter
			.DDMMYYYYHHMMToUTC(`${formattedData.humanEndDate} ${formattedData.endTime}`);

		commit(GetDateTimeSuccess, formattedData);
	},
	[ResetDateTime]: ({ commit }) =>
	{
		commit(ResetDateTime);
	},
	[OpenDateTimePicker]: ({ commit }) =>
	{
		commit(OpenDateTimePicker);
	},
	[GetSelectedPeriod]: ({ commit }, selectedPeriod) =>
	{
		switch (selectedPeriod)
		{
		case i18n.t("Event.SettingCustomPeriods.24Hour"):
			commit(GetLastDayPeriod);
			break;
		case i18n.t("Event.SettingCustomPeriods.Last7Days"):
			commit(GetLastWeekPeriod);
			break;
		case i18n.t("Event.SettingCustomPeriods.Last30Days"):
			commit(GetLastMonthPeriod);
			break;
		case i18n.t("Event.SettingCustomPeriods.CustomPeriod"):
			commit(OpenDateTimePicker);
			break;
		default:
			break;
		}
	},
};
const mutations = {
	[GetDateTimeSuccess]: (state, data) =>
	{
		state.startDate = data.startDate;
		state.endDate = data.endDate;
		state.startTime = data.startTime;
		state.endTime = data.endTime;
		state.humanStartDate = data.humanStartDate;
		state.humanEndDate = data.humanEndDate;
		state.APIStartDateTime = data.APIStartDateTime;
		state.APIEndDateTime = data.APIEndDateTime;
		state.status = FetchStatus.Loaded;
	},
	[GetDateTimeError]: (state, err) =>
	{
		state.data = err;
		state.status = FetchStatus.Loaded;
	},
	[ResetDateTime]: () =>
	{
		state.showDateTimePicker = false;
		state.startDate = DateFormatter.START_DATE;
		state.endDate = DateFormatter.END_DATE;
		state.startTime = DateFormatter.TIME_NOW;
		state.endTime = DateFormatter.TIME_NOW;
		state.humanStartDate = DateFormatter.HUMAN_START_DATE;
		state.humanEndDate = DateFormatter.HUMAN_END_DATE;
		state.APIStartDateTime = DateFormatter.API_START_DATE_TIME;
		state.APIEndDateTime = DateFormatter.API_END_DATE_TIME;
		state.status = FetchStatus.Init;
	},
	[GetLastDayPeriod]: (state) =>
	{
		state.showDateTimePicker = false;
		state.startDate = DateFormatter.START_DATE;
		state.endDate = DateFormatter.END_DATE;
		state.startTime = DateFormatter.TIME_NOW;
		state.endTime = DateFormatter.TIME_NOW;
		state.humanStartDate = DateFormatter.HUMAN_DAY_BEFORE;
		state.humanEndDate = DateFormatter.HUMAN_END_DATE;
		state.APIStartDateTime = DateFormatter.API_DAY_BEFORE;
		state.APIEndDateTime = DateFormatter.API_END_DATE_TIME;
		state.selectedPeriod = "Últimas 24h";
		state.status = FetchStatus.Loaded;
	},
	[GetLastWeekPeriod]: (state) =>
	{
		state.showDateTimePicker = false;
		state.startDate = DateFormatter.START_DATE;
		state.endDate = DateFormatter.END_DATE;
		state.startTime = DateFormatter.TIME_NOW;
		state.endTime = DateFormatter.TIME_NOW;
		state.humanStartDate = DateFormatter.HUMAN_WEEK_BEFORE;
		state.humanEndDate = DateFormatter.HUMAN_END_DATE;
		state.APIStartDateTime = DateFormatter.API_WEEK_BEFORE;
		state.APIEndDateTime = DateFormatter.API_END_DATE_TIME;
		state.selectedPeriod = "Últimos 7 dias";
		state.status = FetchStatus.Loaded;
	},
	[GetLastMonthPeriod]: (state) =>
	{
		state.showDateTimePicker = false;
		state.startDate = DateFormatter.START_DATE;
		state.endDate = DateFormatter.END_DATE;
		state.startTime = DateFormatter.TIME_NOW;
		state.endTime = DateFormatter.TIME_NOW;
		state.humanStartDate = DateFormatter.HUMAN_MONTH_BEFORE;
		state.humanEndDate = DateFormatter.HUMAN_END_DATE;
		state.APIStartDateTime = DateFormatter.API_MONTH_BEFORE;
		state.APIEndDateTime = DateFormatter.API_END_DATE_TIME;
		state.selectedPeriod = "Últimos 30 dias";
		state.status = FetchStatus.Loaded;
	},
	[OpenDateTimePicker]: (state) =>
	{
		state.showDateTimePicker = true;
	},
};

export default {
	state,
	actions,
	mutations,
};
